import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { getListeEquipeMission } from "../../../data/exercice";
import { getListeIdentificationMission } from "../../../data/rateau";
import { ClockCircleOutlined } from "@ant-design/icons";
import { getListeTacheActive } from "../../../data/params/tache";
import { getListeInterventionActive } from "../../../data/params/intervention";
import { getListeRole } from "../../../data/params/role";
import TableTitle from "../../common/TableTitle";
import { appTheme } from "../../../config/theme";
import { FormContainer, TagItem } from "../../common/common.components";
import PageLabel from "../../common/PageLabel/PageLabel";
import SearchRow from "../../common/SearchRow";
import FormLabel from "../../common/Form/FormLabel";
import { getListeSommaireActive } from "../../../data/params/sommaire";
import { getListeRoleMission } from "../../../data/params/RoleMission";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faFileUpload,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import ReactToPrint from "react-to-print";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Identification = ({ mission, client }) => {
  const [identifications, setIdentifications] = useState([]);
  const [equipeIdentifications, setEquipeIdentifications] = useState([]);
  const [filtersItems, setFiltersItems] = useState([]);
  const [taches, setTaches] = useState([]);
  const [interventions, setInterventions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sommairesTable, setSommairesTable] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const componentRef = useRef();

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const [paramsRecherche, setParamsRecherche] = useState({
    infosUser: "",
    tache_id: null,
    intervention_id: null,
    role_id: null,
    reference: null,
    date_debut: null,
    date_fin: null,
  });

  useEffect(() => {
    if (mission) {
      setLoading(true);
      getListeIdentificationMission(mission.id)
        .then((res) => {
          setIdentifications(
            res.result.sort((p1, p2) => {
              return new Date(p2.createdAt) - new Date(p1.createdAt);
            })
          );
          setFiltersItems(
            res.result.sort((p1, p2) => {
              return new Date(p2.createdAt) - new Date(p1.createdAt);
            })
          );
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [mission]);

  const fetchListeTache = async () => {
    setLoading(true);
    getListeTacheActive()
      .then((res) => {
        setTaches(res?.result);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const fetchIntervention = async () => {
    setLoading(true);
    getListeInterventionActive()
      .then((res) => {
        setInterventions(res?.result);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const fetchRole = async () => {
    setLoading(true);
    //getListeRole()
    getListeRoleMission()
      .then((res) => {
        setRoles(res.sort((a, b) => a.libelle.localeCompare(b.libelle)));
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRole();
    fetchListeTache();
    fetchIntervention();
  }, []);

  const fetchEquipes = async (id) => {
    setLoading(true);
    getListeEquipeMission(id)
      .then((res) => {
        const updatedIdentifications = identifications.map((item) => {
          const user = res.find((key) => key.membre_id === item.Lea_User?.id);
          return user ? { ...item, role: user.Lea_RoleMission } : item;
        });
        setEquipeIdentifications(
          res.length > 0 ? updatedIdentifications : identifications
        );
        setFiltersItems(
          res.length > 0 ? updatedIdentifications : identifications
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchEquipes(mission.id);
  }, [mission, identifications]);

  const fetchSommaire = () => {
    getListeSommaireActive().then((res) => {
      setSommairesTable(res.result);
    });
  };

  useEffect(() => {
    fetchSommaire();
  }, []);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setEquipeIdentifications([]);
    }
  };

  const columns = [
    {
      title: () => <TableTitle>Nom et Prénoms / Initial</TableTitle>,
      dataIndex: "name",

      render: (_, record) => (
        <>
          <span style={{ color: "#000", fontWeight: "bold" }}>
            {record.Lea_User?.nom_user + " " + record.Lea_User?.prenom_user}
          </span>
          <br />
          {record.Lea_User?.initial && (
            <Tag prefix="@" color={appTheme.colors.primary_blue}>
              {"@"}
              {record.Lea_User?.initial}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: () => <TableTitle>Rôle</TableTitle>,
      dataIndex: "titre",
      width: 150,
      render: (_, record) => (
        <TagItem color={appTheme.colors.primary_blue}>
          {record?.role?.libelle}
        </TagItem>
      ),
    },
    {
      title: () => <TableTitle>Interventions</TableTitle>,
      width: 200,
      dataIndex: "interventionType",
      render: (_, record) => (
        <TagItem>{record.Bog_Intervention?.libelle}</TagItem>
      ),
    },
    {
      title: () => <TableTitle>Date</TableTitle>,
      dataIndex: "date",
      width: 150,
      render: (_, record) => (
        <span
          className="chart-blue display-block f-size-12"
          style={{ fontWeight: 600 }}
        >
          {record?.dateAdd && (
            <>
              <ClockCircleOutlined style={{ fontSize: "15px" }} />{" "}
              {moment(record?.dateAdd).format("DD/MM/YYYY")}
            </>
          )}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Heure d'entrée</TableTitle>,
      dataIndex: "heureEntree",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder fs-7">
          {record?.heureEntree !== record?.heureSortie && (
            <> {record?.heureEntree}</>
          )}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Heure de sortie</TableTitle>,
      dataIndex: "heureSortie",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder fs-7">
          {record?.heureSortie !== record?.heureEntree && (
            <> {record?.heureSortie}</>
          )}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Tâches</TableTitle>,
      dataIndex: "intervention",
      width: 200,
      render: (_, record) => (
        <TagItem>{record.Bog_TacheAutorise?.libelle}</TagItem>
      ),
    },
    {
      title: () => <TableTitle>Reference</TableTitle>,
      dataIndex: "reference",
      width: 100,
      render: (_, record) =>
        record.codeSommaire && (
          <Tag color={appTheme.colors.primary}>{record.codeSommaire}</Tag>
        ),
    },
    {
      title: () => <TableTitle>Dossier client</TableTitle>,
      dataIndex: "dossiers",
      render: () => (
        <div className="d-flex flex-column">
          <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>
            {client?.sigle || ""}
          </span>
          <span
            className="text-gray-800 fw-bold text-hover-primary mb-1"
            style={{ fontSize: "12px" }}
          >
            {mission.mission}{" "}
            <span className="ms-3">
              {mission.annee && (
                <TagItem color={appTheme.colors.primary}>
                  {mission.annee}
                </TagItem>
              )}
            </span>
          </span>
        </div>
      ),
    },
  ];

  const handleSearch = () => {
    setLoading(true);
    setTimeout(() => {
      const filteredClients = equipeIdentifications.filter((ident) => {
        // Recherche utilisateur Lea_User?.nom_user
        const infosUser = paramsRecherche.infosUser?.toLowerCase() || "";
        const matchUser =
          !infosUser ||
          ident.Lea_User?.initial?.toLowerCase().includes(infosUser) ||
          ident.Lea_User?.nom_user?.toLowerCase().includes(infosUser) ||
          ident.Lea_User?.prenom_user?.toLowerCase().includes(infosUser) ||
          ident.Lea_User?.telephone1_user?.toLowerCase().includes(infosUser) ||
          ident.Lea_User?.email_user?.toLowerCase().includes(infosUser);

        // Filtre rôle
        const matchRole =
          !paramsRecherche.role_id ||
          ident.role?.id === paramsRecherche.role_id;

        // Filtre tâche
        const matchTache =
          !paramsRecherche.tache_id ||
          ident.Bog_TacheAutorise?.id === paramsRecherche.tache_id;

        // Filtre intervention
        const matchIntervention =
          !paramsRecherche.intervention_id ||
          ident.Bog_Intervention?.id === paramsRecherche.intervention_id;

        // Filtre référence (sommaire)
        const matchReference =
          !paramsRecherche.reference ||
          ident.codeSommaire === paramsRecherche.reference;

        // Filtre date
        let matchDate = true;
        if (paramsRecherche.date_debut && paramsRecherche.date_fin) {
          matchDate = moment(ident.createdAt).isBetween(
            moment(paramsRecherche.date_debut, "YYYY-MM-DD"),
            moment(paramsRecherche.date_fin, "YYYY-MM-DD"),
            undefined,
            "[]"
          );
        } else if (paramsRecherche.date_debut) {
          matchDate = moment(ident.createdAt).isSameOrAfter(
            moment(paramsRecherche.date_debut, "YYYY-MM-DD")
          );
        } else if (paramsRecherche.date_fin) {
          matchDate = moment(ident.createdAt).isSameOrBefore(
            moment(paramsRecherche.date_fin, "YYYY-MM-DD")
          );
        }

        return (
          matchUser &&
          matchRole &&
          matchTache &&
          matchIntervention &&
          matchReference &&
          matchDate
        );
      });

      setFiltersItems(filteredClients);
      setLoading(false);
    }, 500);
  };

  const handleReset = () => {
    setLoading(true);

    // ✅ Réinitialisation complète des paramètres
    const resetParams = {
      infosUser: "",
      tache_id: null,
      intervention_id: null,
      role_id: null,
      reference: null,
      date_debut: null,
      date_fin: null,
    };

    setParamsRecherche(resetParams);

    setTimeout(() => {
      setFiltersItems(equipeIdentifications);
      setLoading(false);
    }, 0);
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  // Styles pour l'impression PDF
  const pageStyle = `
    @page {
      size: A4;
      margin: 15mm;
      margin-top: 20mm;
      margin-bottom: 20mm;
      
      @top-center {
        content: "EGOU EXPERT - Historique des Interventions";
        font-size: 12px;
        font-weight: bold;
        color: #333;
      }
      
      @bottom-right {
        content: "Page " counter(page) " / " counter(pages);
        font-size: 10px;
        color: #666;
      }
    }
    
    @media print {
      body {
        font-family: 'Arial', sans-serif;
        font-size: 11px;
        line-height: 1.3;
        color: #333;
        margin: 0;
        background: white;
      }
      
      .print-container {
        padding: 20px;
        background: white;
      }
      
      .print-header {
        text-align: center;
        margin-bottom: 25px;
        border-bottom: 2px solid #1890ff;
        padding-bottom: 15px;
      }
      
      .print-title {
        font-size: 20px;
        font-weight: bold;
        color: #1890ff;
        margin-bottom: 8px;
      }
      
      .print-subtitle {
        font-size: 16px;
        color: #666;
        margin-bottom: 15px;
      }
      
      .print-client-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 15px;
        background-color: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
      }
      
      .print-info-item {
        font-size: 12px;
        line-height: 1.5;
      }
      
      .print-info-label {
        font-weight: bold;
        color: #1890ff;
        display: block;
        margin-bottom: 3px;
      }
      
      .print-stats {
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
        padding: 15px;
        background-color: #f0f8ff;
        border-radius: 8px;
        border: 1px solid #d6e9ff;
      }
      
      .print-stat-item {
        text-align: center;
        font-size: 11px;
      }
      
      .print-stat-number {
        font-size: 18px;
        font-weight: bold;
        color: #1890ff;
        display: block;
        margin-bottom: 5px;
      }
      
      .print-table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
        font-size: 9px;
      }
      
      .print-table th {
        background-color: #1890ff !important;
        color: white !important;
        font-weight: bold !important;
        padding: 8px 4px !important;
        border: 1px solid #ccc !important;
        text-align: center !important;
        font-size: 10px !important;
      }
      
      .print-table td {
        padding: 6px 4px !important;
        border: 1px solid #ddd !important;
        font-size: 9px !important;
        vertical-align: top !important;
        line-height: 1.3;
      }
      
      .print-table tbody tr:nth-child(even) {
        background-color: #f9f9f9 !important;
      }
      
      .print-tag {
        display: inline-block;
        padding: 2px 6px;
        background-color: #1890ff;
        color: white;
        border-radius: 4px;
        font-size: 8px;
        font-weight: bold;
        margin: 1px;
      }
      
      .print-tag-secondary {
        background-color: #52c41a;
      }
      
      .print-tag-info {
        background-color: #13c2c2;
      }
      
      .print-footer {
        margin-top: 30px;
        padding-top: 15px;
        border-top: 1px solid #ddd;
        text-align: center;
        font-size: 10px;
        color: #666;
      }
      
      .print-user-name {
        font-weight: bold;
        color: #333;
        font-size: 10px;
        line-height: 1.2;
      }
      
      .print-date {
        font-weight: bold;
        color: #1890ff;
        font-size: 9px;
      }
      
      .print-time {
        font-weight: bold;
        color: #333;
        font-size: 9px;
      }
      
      /* Masquer les éléments non nécessaires */
      .no-print {
        display: none !important;
      }
      
      /* Éviter les coupures de page dans les lignes */
      .print-table tbody tr {
        page-break-inside: avoid;
      }
    }
  `;

  // Composant d'impression
  const PrintComponent = React.forwardRef((props, ref) => {
    // Calcul des statistiques
    const statistiques = {
      totalInterventions: filtersItems.length,
      totalHeures: filtersItems
        .reduce((total, item) => {
          const entree = moment(item.heureEntree, "HH:mm");
          const sortie = moment(item.heureSortie, "HH:mm");
          if (entree.isValid() && sortie.isValid() && sortie.isAfter(entree)) {
            return total + sortie.diff(entree, "hours", true);
          }
          return total;
        }, 0)
        .toFixed(1),
      utilisateursUniques: [
        ...new Set(
          filtersItems.map((item) => item.Lea_User?.id).filter(Boolean)
        ),
      ].length,
      derniereIntervention:
        filtersItems.length > 0
          ? moment(
              Math.max(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A",
      premiereIntervention:
        filtersItems.length > 0
          ? moment(
              Math.min(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A",
    };

    return (
      <div ref={ref} className="print-container">
        {/* En-tête */}
        <div className="print-header">
          <div className="print-title">EGOU EXPERT</div>
          <div className="print-subtitle">Historique des Interventions</div>

          <div className="print-client-info">
            <div className="print-info-item">
              <span className="print-info-label">Client :</span>
              <span>
                {client?.sigle} - {client?.denomination || "N/A"}
              </span>
            </div>
            <div className="print-info-item">
              <span className="print-info-label">Mission :</span>
              <span>
                {mission?.mission} {mission?.annee}
              </span>
            </div>
            <div className="print-info-item">
              <span className="print-info-label">Date d'édition :</span>
              <span>{moment().format("DD/MM/YYYY à HH:mm")}</span>
            </div>
          </div>

          {/* Statistiques */}
          <div className="print-stats">
            <div className="print-stat-item">
              <span className="print-stat-number">
                {statistiques.totalInterventions}
              </span>
              <span>Interventions</span>
            </div>
            <div className="print-stat-item">
              <span className="print-stat-number">
                {statistiques.totalHeures}h
              </span>
              <span>Heures totales</span>
            </div>
            <div className="print-stat-item">
              <span className="print-stat-number">
                {statistiques.utilisateursUniques}
              </span>
              <span>Intervenants</span>
            </div>
            <div className="print-stat-item">
              <span className="print-stat-number">
                {statistiques.premiereIntervention !== "N/A" &&
                statistiques.derniereIntervention !== "N/A"
                  ? moment(
                      statistiques.derniereIntervention,
                      "DD/MM/YYYY"
                    ).diff(
                      moment(statistiques.premiereIntervention, "DD/MM/YYYY"),
                      "days"
                    ) + 1
                  : "N/A"}
              </span>
              <span>Jours</span>
            </div>
          </div>
        </div>

        {/* Tableau des interventions */}
        <table className="print-table">
          <thead>
            <tr>
              <th style={{ width: "15%" }}>Intervenant</th>
              <th style={{ width: "10%" }}>Rôle</th>
              <th style={{ width: "12%" }}>Intervention</th>
              <th style={{ width: "15%" }}>Tâche</th>
              <th style={{ width: "10%" }}>Date</th>
              <th style={{ width: "8%" }}>Entrée</th>
              <th style={{ width: "8%" }}>Sortie</th>
              <th style={{ width: "8%" }}>Réf.</th>
              <th style={{ width: "14%" }}>Mission</th>
            </tr>
          </thead>
          <tbody>
            {filtersItems.map((record, index) => (
              <tr key={record.id || index}>
                <td>
                  <div className="print-user-name">
                    {record.Lea_User?.nom_user} {record.Lea_User?.prenom_user}
                  </div>
                  {record.Lea_User?.initial && (
                    <div
                      style={{
                        fontSize: "8px",
                        color: "#666",
                        marginTop: "2px",
                      }}
                    >
                      @{record.Lea_User?.initial}
                    </div>
                  )}
                </td>
                <td>
                  {record?.role?.libelle && (
                    <span className="print-tag print-tag-secondary">
                      {record.role.libelle}
                    </span>
                  )}
                </td>
                <td>
                  {record.Bog_Intervention?.libelle && (
                    <span style={{ fontSize: "9px" }}>
                      {record.Bog_Intervention.libelle}
                    </span>
                  )}
                </td>
                <td>
                  {record.Bog_TacheAutorise?.libelle && (
                    <span style={{ fontSize: "9px" }}>
                      {record.Bog_TacheAutorise.libelle}
                    </span>
                  )}
                </td>
                <td>
                  {record?.dateAdd && (
                    <span className="print-date">
                      {moment(record.dateAdd).format("DD/MM/YYYY")}
                    </span>
                  )}
                </td>
                <td>
                  <span className="print-time">
                    {record?.heureEntree || ""}
                  </span>
                </td>
                <td>
                  <span className="print-time">
                    {record?.heureSortie || ""}
                  </span>
                </td>
                <td>
                  {record.codeSommaire && (
                    <span className="print-tag">{record.codeSommaire}</span>
                  )}
                </td>
                <td>
                  <div style={{ fontSize: "9px" }}>
                    <div style={{ fontWeight: "bold", color: "#1890ff" }}>
                      {client?.sigle}
                    </div>
                    <div style={{ color: "#666" }}>
                      {mission.mission} {mission.annee}
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pied de page */}
        <div className="print-footer">
          <div style={{ marginBottom: "8px" }}>
            <strong>Résumé :</strong> {filtersItems.length} intervention(s)
            enregistrée(s)
            {statistiques.premiereIntervention !== "N/A" &&
              statistiques.derniereIntervention !== "N/A" && (
                <span>
                  {" "}
                  du {statistiques.premiereIntervention} au{" "}
                  {statistiques.derniereIntervention}
                </span>
              )}
          </div>
          <div style={{ fontSize: "9px", color: "#999" }}>
            Document généré le {moment().format("DD/MM/YYYY à HH:mm")} par EGOU
            EXPERT - Système de gestion des missions d'expertise comptable
          </div>
        </div>
      </div>
    );
  });

  // Fonction d'export Excel
  const handleExportExcel = () => {
    try {
      // Préparation des données pour Excel
      const excelData = filtersItems.map((item, index) => {
        const entree = moment(item.heureEntree, "HH:mm");
        const sortie = moment(item.heureSortie, "HH:mm");
        const duree =
          entree.isValid() && sortie.isValid() && sortie.isAfter(entree)
            ? sortie.diff(entree, "hours", true).toFixed(2) + "h"
            : "N/A";

        return {
          "#": index + 1,
          "Nom & Prénom": `${item.Lea_User?.nom_user || ""} ${
            item.Lea_User?.prenom_user || ""
          }`.trim(),
          Initial: item.Lea_User?.initial || "",
          Rôle: item?.role?.libelle || "",
          Intervention: item.Bog_Intervention?.libelle || "",
          Tâche: item.Bog_TacheAutorise?.libelle || "",
          Date: item?.dateAdd ? moment(item.dateAdd).format("DD/MM/YYYY") : "",
          "Heure Entrée": item?.heureEntree || "",
          "Heure Sortie": item?.heureSortie || "",
          Durée: duree,
          "Code Sommaire": item.codeSommaire || "",
          "Sigle Client": client?.sigle || "",
          Dénomination: client?.denomination || "",
          Mission: mission?.mission || "",
          Année: mission?.annee || "",
          "Date Création": item.createdAt
            ? moment(item.createdAt).format("DD/MM/YYYY HH:mm")
            : "",
        };
      });

      // Calcul des statistiques pour la feuille résumé
      const totalInterventions = filtersItems.length;
      const totalHeures = filtersItems
        .reduce((total, item) => {
          const entree = moment(item.heureEntree, "HH:mm");
          const sortie = moment(item.heureSortie, "HH:mm");
          if (entree.isValid() && sortie.isValid() && sortie.isAfter(entree)) {
            return total + sortie.diff(entree, "hours", true);
          }
          return total;
        }, 0)
        .toFixed(2);

      const utilisateursUniques = [
        ...new Set(
          filtersItems.map((item) => item.Lea_User?.id).filter(Boolean)
        ),
      ];
      const derniereIntervention =
        filtersItems.length > 0
          ? moment(
              Math.max(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A";
      const premiereIntervention =
        filtersItems.length > 0
          ? moment(
              Math.min(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A";

      // Données de résumé
      const resumeData = [
        {
          Indicateur: "Client",
          Valeur: `${client?.sigle} - ${client?.denomination}`,
        },
        {
          Indicateur: "Mission",
          Valeur: `${mission?.mission} ${mission?.annee}`,
        },
        {
          Indicateur: "Date d'édition",
          Valeur: moment().format("DD/MM/YYYY à HH:mm"),
        },
        { Indicateur: "", Valeur: "" },
        { Indicateur: "Total interventions", Valeur: totalInterventions },
        { Indicateur: "Total heures", Valeur: totalHeures + "h" },
        {
          Indicateur: "Nombre d'intervenants",
          Valeur: utilisateursUniques.length,
        },
        { Indicateur: "Première intervention", Valeur: premiereIntervention },
        { Indicateur: "Dernière intervention", Valeur: derniereIntervention },
        {
          Indicateur: "Période (jours)",
          Valeur:
            premiereIntervention !== "N/A" && derniereIntervention !== "N/A"
              ? moment(derniereIntervention, "DD/MM/YYYY").diff(
                  moment(premiereIntervention, "DD/MM/YYYY"),
                  "days"
                ) + 1
              : "N/A",
        },
      ];

      // Données par intervenant
      const intervenantsData = utilisateursUniques.map((userId) => {
        const userInterventions = filtersItems.filter(
          (item) => item.Lea_User?.id === userId
        );
        const user = userInterventions[0]?.Lea_User;
        const totalHeuresUser = userInterventions
          .reduce((total, item) => {
            const entree = moment(item.heureEntree, "HH:mm");
            const sortie = moment(item.heureSortie, "HH:mm");
            if (
              entree.isValid() &&
              sortie.isValid() &&
              sortie.isAfter(entree)
            ) {
              return total + sortie.diff(entree, "hours", true);
            }
            return total;
          }, 0)
          .toFixed(2);

        return {
          "Nom & Prénom": `${user?.nom_user || ""} ${
            user?.prenom_user || ""
          }`.trim(),
          Initial: user?.initial || "",
          "Nombre d'interventions": userInterventions.length,
          "Total heures": totalHeuresUser + "h",
          "Pourcentage interventions":
            ((userInterventions.length / totalInterventions) * 100).toFixed(1) +
            "%",
          "Pourcentage heures":
            totalHeures > 0
              ? ((totalHeuresUser / totalHeures) * 100).toFixed(1) + "%"
              : "0%",
          "Première intervention":
            userInterventions.length > 0
              ? moment(
                  Math.min(
                    ...userInterventions.map((item) => new Date(item.createdAt))
                  )
                ).format("DD/MM/YYYY")
              : "N/A",
          "Dernière intervention":
            userInterventions.length > 0
              ? moment(
                  Math.max(
                    ...userInterventions.map((item) => new Date(item.createdAt))
                  )
                ).format("DD/MM/YYYY")
              : "N/A",
        };
      });

      // Création du workbook
      const wb = XLSX.utils.book_new();

      // Feuille 1: Données détaillées
      const ws1 = XLSX.utils.json_to_sheet(excelData);

      // Définir les largeurs des colonnes pour la feuille détaillée
      ws1["!cols"] = [
        { wch: 5 }, // #
        { wch: 25 }, // Nom & Prénom
        { wch: 10 }, // Initial
        { wch: 15 }, // Rôle
        { wch: 20 }, // Intervention
        { wch: 25 }, // Tâche
        { wch: 12 }, // Date
        { wch: 12 }, // Heure Entrée
        { wch: 12 }, // Heure Sortie
        { wch: 10 }, // Durée
        { wch: 15 }, // Code Sommaire
        { wch: 15 }, // Sigle Client
        { wch: 30 }, // Dénomination
        { wch: 20 }, // Mission
        { wch: 8 }, // Année
        { wch: 18 }, // Date Création
      ];

      XLSX.utils.book_append_sheet(wb, ws1, "Interventions Détaillées");

      // Feuille 2: Résumé
      const ws2 = XLSX.utils.json_to_sheet(resumeData);
      ws2["!cols"] = [
        { wch: 25 }, // Indicateur
        { wch: 40 }, // Valeur
      ];
      XLSX.utils.book_append_sheet(wb, ws2, "Résumé");

      // Feuille 3: Analyse par intervenant
      const ws3 = XLSX.utils.json_to_sheet(intervenantsData);
      ws3["!cols"] = [
        { wch: 25 }, // Nom & Prénom
        { wch: 10 }, // Initial
        { wch: 20 }, // Nombre d'interventions
        { wch: 15 }, // Total heures
        { wch: 22 }, // Pourcentage interventions
        { wch: 18 }, // Pourcentage heures
        { wch: 18 }, // Première intervention
        { wch: 18 }, // Dernière intervention
      ];
      XLSX.utils.book_append_sheet(wb, ws3, "Analyse Intervenants");

      // Génération du fichier
      const fileName = `EGOU-EXPERT-Interventions-${
        client?.sigle || "CLIENT"
      }-${mission?.annee || "ANNEE"}-${moment().format("DDMMYYYY")}.xlsx`;
      XLSX.writeFile(wb, fileName);

      // Fermer le menu et afficher un message de succès
      setIsMenuOpen(false);
      console.log("Export Excel terminé");
    } catch (error) {
      console.error("Erreur lors de l'export Excel:", error);
    }
  };

  // Fonction d'export Word
  const handleExportWord = () => {
    try {
      // Calcul des statistiques
      const totalInterventions = filtersItems.length;
      const totalHeures = filtersItems
        .reduce((total, item) => {
          const entree = moment(item.heureEntree, "HH:mm");
          const sortie = moment(item.heureSortie, "HH:mm");
          if (entree.isValid() && sortie.isValid() && sortie.isAfter(entree)) {
            return total + sortie.diff(entree, "hours", true);
          }
          return total;
        }, 0)
        .toFixed(1);

      const utilisateursUniques = [
        ...new Set(
          filtersItems.map((item) => item.Lea_User?.id).filter(Boolean)
        ),
      ].length;

      const derniereIntervention =
        filtersItems.length > 0
          ? moment(
              Math.max(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A";

      const premiereIntervention =
        filtersItems.length > 0
          ? moment(
              Math.min(...filtersItems.map((item) => new Date(item.createdAt)))
            ).format("DD/MM/YYYY")
          : "N/A";

      // Génération du contenu HTML pour Word
      const title = "EGOU EXPERT - Historique des Interventions";

      // En-tête avec informations
      const headerContent = `
        <div style="text-align: center; margin-bottom: 30px; border-bottom: 3px solid #1890ff; padding-bottom: 20px;">
          <h1 style="color: #1890ff; font-size: 24px; margin: 0; font-weight: bold;">EGOU EXPERT</h1>
          <h2 style="color: #666; font-size: 18px; margin: 10px 0; font-weight: normal;">Historique des Interventions</h2>
        </div>
      `;

      // Informations client et mission
      const clientInfoContent = `
        <table style="width: 100%; margin-bottom: 25px; border: 1px solid #e9ecef; border-collapse: collapse; background-color: #f8f9fa;">
          <tr style="background-color: #f1f3f4;">
            <td style="padding: 12px; font-weight: bold; color: #1890ff; border: 1px solid #e9ecef; width: 25%;">Client :</td>
            <td style="padding: 12px; border: 1px solid #e9ecef;">${
              client?.sigle
            } - ${client?.denomination || "N/A"}</td>
          </tr>
          <tr>
            <td style="padding: 12px; font-weight: bold; color: #1890ff; border: 1px solid #e9ecef;">Mission :</td>
            <td style="padding: 12px; border: 1px solid #e9ecef;">${
              mission?.mission
            } ${mission?.annee}</td>
          </tr>
          <tr style="background-color: #f1f3f4;">
            <td style="padding: 12px; font-weight: bold; color: #1890ff; border: 1px solid #e9ecef;">Date d'édition :</td>
            <td style="padding: 12px; border: 1px solid #e9ecef;">${moment().format(
              "DD/MM/YYYY à HH:mm"
            )}</td>
          </tr>
        </table>
      `;

      // Statistiques
      const statsContent = `
        <div style="margin: 25px 0; padding: 20px; background-color: #f0f8ff; border: 1px solid #d6e9ff; border-radius: 8px;">
          <h3 style="text-align: center; color: #1890ff; margin-bottom: 20px; font-size: 18px;">Statistiques Générales</h3>
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td style="text-align: center; padding: 15px; width: 25%;">
                <div style="font-size: 24px; font-weight: bold; color: #1890ff; margin-bottom: 5px;">${totalInterventions}</div>
                <div style="font-size: 14px; color: #333;">Interventions</div>
              </td>
              <td style="text-align: center; padding: 15px; width: 25%;">
                <div style="font-size: 24px; font-weight: bold; color: #1890ff; margin-bottom: 5px;">${totalHeures}h</div>
                <div style="font-size: 14px, color: #333;">Heures totales</div>
              </td>
              <td style="text-align: center; padding: 15px; width: 25%;">
                <div style="font-size: 24px; font-weight: bold; color: #1890ff; margin-bottom: 5px;">${utilisateursUniques}</div>
                <div style="font-size: 14px; color: #333;">Intervenants</div>
              </td>
              <td style="text-align: center; padding: 15px; width: 25%;">
                <div style="font-size: 24px; font-weight: bold; color: #1890ff; margin-bottom: 5px;">${
                  premiereIntervention !== "N/A" &&
                  derniereIntervention !== "N/A"
                    ? moment(derniereIntervention, "DD/MM/YYYY").diff(
                        moment(premiereIntervention, "DD/MM/YYYY"),
                        "days"
                      ) + 1
                    : "N/A"
                }</div>
                <div style="font-size: 14px; color: #333;">Jours</div>
              </td>
            </tr>
          </table>
        </div>
      `;

      // Tableau des interventions
      const tableHeader = `
        <h3 style="color: #1890ff; margin: 30px 0 15px 0; font-size: 18px;">Détail des Interventions</h3>
        <table style="width: 100%; border-collapse: collapse; font-size: 11px; margin-bottom: 25px;">
          <thead>
            <tr style="background-color: #1890ff; color: white;">
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Intervenant</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Rôle</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Intervention</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Tâche</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Date</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Entrée</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Sortie</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Réf.</th>
              <th style="border: 1px solid #ccc; padding: 10px; text-align: center; font-weight: bold;">Mission</th>
            </tr>
          </thead>
          <tbody>
      `;

      // Génération des lignes du tableau
      const tableRows = filtersItems
        .map((record, index) => {
          const backgroundColor = index % 2 === 0 ? "#f9f9f9" : "white";

          return `
          <tr style="background-color: ${backgroundColor};">
            <td style="border: 1px solid #ddd; padding: 8px; vertical-align: top;">
              <div style="font-weight: bold; font-size: 11px; color: #333; line-height: 1.3;">
                ${record.Lea_User?.nom_user || ""} ${
            record.Lea_User?.prenom_user || ""
          }
              </div>
              ${
                record.Lea_User?.initial
                  ? `
                <div style="font-size: 9px; color: #666; margin-top: 2px;">
                  @${record.Lea_User.initial}
                </div>
              `
                  : ""
              }
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
              ${
                record?.role?.libelle
                  ? `
                <span style="background-color: #52c41a; color: white; padding: 3px 6px; border-radius: 4px; font-size: 9px; font-weight: bold;">
                  ${record.role.libelle}
                </span>
              `
                  : ""
              }
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; font-size: 10px;">
              ${record.Bog_Intervention?.libelle || ""}
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; font-size: 10px;">
              ${record.Bog_TacheAutorise?.libelle || ""}
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
              ${
                record?.dateAdd
                  ? `
                <span style="font-weight: bold; color: #1890ff; font-size: 10px;">
                  ${moment(record.dateAdd).format("DD/MM/YYYY")}
                </span>
              `
                  : ""
              }
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold; font-size: 10px;">
              ${record?.heureEntree || ""}
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold; font-size: 10px;">
              ${record?.heureSortie || ""}
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">
              ${
                record.codeSommaire
                  ? `
                <span style="background-color: #1890ff; color: white; padding: 3px 6px; border-radius: 4px; font-size: 9px; font-weight: bold;">
                  ${record.codeSommaire}
                </span>
              `
                  : ""
              }
            </td>
            <td style="border: 1px solid #ddd; padding: 8px; font-size: 10px;">
              <div style="font-weight: bold; color: #1890ff; margin-bottom: 2px;">
                ${client?.sigle || ""}
              </div>
              <div style="color: #666;">
                ${mission.mission} ${mission.annee}
              </div>
            </td>
          </tr>
        `;
        })
        .join("");

      const tableFooter = `
          </tbody>
        </table>
      `;

      // Pied de page
      const footerContent = `
        <div style="margin-top: 40px; padding-top: 20px; border-top: 2px solid #ddd; text-align: center; font-size: 12px; color: #666;">
          <div style="margin-bottom: 10px; font-size: 14px; font-weight: bold; color: #333;">
            <strong>Résumé :</strong> ${
              filtersItems.length
            } intervention(s) enregistrée(s)
            ${
              premiereIntervention !== "N/A" && derniereIntervention !== "N/A"
                ? ` du ${premiereIntervention} au ${derniereIntervention}`
                : ""
            }
          </div>
          <div style="font-size: 11px; color: #999; margin-top: 10px;">
            Document généré le ${moment().format(
              "DD/MM/YYYY à HH:mm"
            )} par EGOU EXPERT<br/>
            Système de gestion des missions d'expertise comptable
          </div>
        </div>
      `;

      // Assemblage du contenu complet
      const content =
        headerContent +
        clientInfoContent +
        statsContent +
        tableHeader +
        tableRows +
        tableFooter +
        footerContent;

      // Contenu HTML complet avec styles Word - MARGES RÉDUITES
      const fullContent = `
        <html xmlns:o='urn:schemas-microsoft-com:office:office'
              xmlns:w='urn:schemas-microsoft-com:office:word'
              xmlns='http://www.w3.org/TR/REC-html40'>
        <head>
          <meta http-equiv="Content-Type" content="text/html;charset=UTF-8"/>
          <title>${title}</title>
          <style>
            @page {
              size: A4;
              margin: 1cm; /* ✅ Réduction des marges de 2cm à 1cm */
            }
            body {
              font-family: 'Calibri', 'Arial', sans-serif;
              font-size: 10pt; /* ✅ Réduction de la taille de police de 11pt à 10pt */
              line-height: 1.3; /* ✅ Réduction de l'interligne de 1.4 à 1.3 */
              color: #333;
              margin: 0;
              padding: 10px; /* ✅ Réduction du padding de 20px à 10px */
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 10px; /* ✅ Réduction de 15px à 10px */
            }
            th, td {
              border: 1px solid #ddd;
              padding: 6px; /* ✅ Réduction de 8px à 6px */
              text-align: left;
              vertical-align: top;
              font-size: 9pt; /* ✅ Taille de police réduite pour les cellules */
            }
            th {
              background-color: #1890ff;
              color: white;
              font-weight: bold;
              text-align: center;
              padding: 8px 4px; /* ✅ Padding spécifique pour les en-têtes */
            }
            .header-table td {
              border: 1px solid #e9ecef;
              padding: 8px; /* ✅ Réduction de 12px à 8px */
            }
            .stats-box {
              background-color: #f0f8ff;
              border: 1px solid #d6e9ff;
              border-radius: 6px; /* ✅ Réduction de 8px à 6px */
              padding: 15px; /* ✅ Réduction de 20px à 15px */
              margin: 15px 0; /* ✅ Réduction de 20px à 15px */
            }
            .tag {
              display: inline-block;
              padding: 2px 6px; /* ✅ Réduction de 3px 8px à 2px 6px */
              border-radius: 3px; /* ✅ Réduction de 4px à 3px */
              font-size: 8pt; /* ✅ Réduction de 9pt à 8pt */
              font-weight: bold;
              margin: 1px;
            }
            .tag-blue { background-color: #1890ff; color: white; }
            .tag-green { background-color: #52c41a; color: white; }
            
            /* ✅ Styles spécifiques pour optimiser l'espace */
            h1 {
              margin: 0 0 8px 0; /* ✅ Réduction des marges */
              font-size: 22px; /* ✅ Réduction de 24px à 22px */
            }
            h2 {
              margin: 5px 0 10px 0; /* ✅ Réduction des marges */
              font-size: 16px; /* ✅ Réduction de 18px à 16px */
            }
            h3 {
              margin: 20px 0 10px 0; /* ✅ Réduction des marges */
              font-size: 16px; /* ✅ Réduction de 18px à 16px */
            }
            
            /* ✅ Optimisation des espaces dans les sections */
            .header-section {
              margin-bottom: 20px; /* ✅ Réduction de 30px à 20px */
              border-bottom: 2px solid #1890ff;
              padding-bottom: 12px; /* ✅ Réduction de 20px à 12px */
            }
            
            .stats-section {
              margin: 15px 0; /* ✅ Réduction de 25px à 15px */
            }
            
            .footer-section {
              margin-top: 25px; /* ✅ Réduction de 40px à 25px */
              padding-top: 15px; /* ✅ Réduction de 20px à 15px */
              border-top: 1px solid #ddd;
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
        </html>
      `;

      // Création et téléchargement du fichier
      const blob = new Blob([fullContent], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const fileName = `EGOU-EXPERT-Interventions-${
        client?.sigle || "CLIENT"
      }-${mission?.annee || "ANNEE"}-${moment().format("DDMMYYYY")}.doc`;

      saveAs(blob, fileName);

      // Fermer le menu
      setIsMenuOpen(false);
      console.log("Export Word terminé");
    } catch (error) {
      console.error("Erreur lors de l'export Word:", error);
    }
  };

  return (
    <>
      <div className="mx-5">
        <PageLabel label="Historique des interventions" />

        <SearchRow
          handleSearch={handleSearch}
          handleReset={handleReset}
          loading={loading}
        >
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <FormLabel label="Utilisateur" />
            <Input
              allowClear
              style={{ width: "100%" }}
              size="large"
              placeholder="Nom, prenom, initial, téléphone, email"
              value={paramsRecherche.infosUser || ""}
              onChange={(e) =>
                setParamsRecherche({
                  ...paramsRecherche,
                  infosUser: e.target.value,
                })
              }
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <FormLabel label="Roles" />
            <Select
              allowClear
              showSearch
              placeholder="Sélectionnez la rôle..."
              optionFilterProp="label"
              value={paramsRecherche.role_id || null}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={roles.map((role) => ({
                value: role.id,
                label: role.libelle,
              }))}
              onChange={(value) =>
                setParamsRecherche({ ...paramsRecherche, role_id: value })
              }
              size="large"
              style={{ width: "100%" }}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <FormLabel label="Interventions" />
            <Select
              allowClear
              showSearch
              placeholder="Sélectionnez l'intervation..."
              optionFilterProp="label"
              value={paramsRecherche.intervention_id || null}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={interventions.map((tache) => ({
                value: tache.id,
                label: tache.libelle,
              }))}
              onChange={(value) =>
                setParamsRecherche({
                  ...paramsRecherche,
                  intervention_id: value,
                })
              }
              size="large"
              style={{ width: "100%" }}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <FormLabel label="Sommaire" />
            <Select
              allowClear
              showSearch
              placeholder="Code du sommaire"
              size="large"
              style={{ width: "100%" }}
              value={paramsRecherche.reference || null}
              onChange={(value) =>
                setParamsRecherche({ ...paramsRecherche, reference: value })
              }
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              options={sommairesTable.map((statut) => ({
                value: statut.libelle,
                label: `${statut.libelle} - ${statut.description}`,
              }))}
            />
          </Col>

          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <FormLabel label="Tâches" />
            <Select
              allowClear
              showSearch
              placeholder="Sélectionnez la tâche..."
              optionFilterProp="label"
              value={paramsRecherche.tache_id || null}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={taches.map((tache) => ({
                value: tache.id,
                label: tache.libelle,
              }))}
              onChange={(value) =>
                setParamsRecherche({ ...paramsRecherche, tache_id: value })
              }
              size="large"
              style={{ width: "100%" }}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 2 }}
            xl={{ span: 2 }}
          >
            <FormLabel label="Date début" />
            <DatePicker
              size="large"
              placeholder="Date début"
              style={{ width: "100%" }}
              allowClear
              value={
                paramsRecherche.date_debut
                  ? moment(paramsRecherche.date_debut, "YYYY-MM-DD")
                  : null
              }
              onChange={(date) =>
                setParamsRecherche({
                  ...paramsRecherche,
                  date_debut: date ? date.format("YYYY-MM-DD") : null,
                })
              }
              format="DD-MM-YYYY"
            />
          </Col>

          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 2 }}
            xl={{ span: 2 }}
          >
            <FormLabel label="Date fin" />
            <DatePicker
              size="large"
              placeholder="Date fin"
              style={{ width: "100%" }}
              allowClear
              value={
                paramsRecherche.date_fin
                  ? moment(paramsRecherche.date_fin, "YYYY-MM-DD")
                  : null
              }
              onChange={(date) =>
                setParamsRecherche({
                  ...paramsRecherche,
                  date_fin: date ? date.format("YYYY-MM-DD") : null,
                })
              }
              format="DD-MM-YYYY"
            />
          </Col>
        </SearchRow>
        <Space className="d-flex justify-content-end pt-4">
          <Tooltip title="Exportation du traitement">
            <div className="d-flex flex-column align-items-center mt-5">
              <Button
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                type="primary"
                icon={<FontAwesomeIcon icon={faUpload} />}
                onClick={toggleMenu}
                size="large"
              >
                Exporter
              </Button>
              {isMenuOpen && (
                <div
                  id="kt_users_lists_views_export_menu"
                  className="menu menu-sub menu-sub-dropdown menu-option menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4 show"
                  data-kt-menu="true"
                  data-popper-placement="bottom-end"
                >
                  <div className="menu-item px-3">
                    <ReactToPrint
                      trigger={() => (
                        <a
                          className="menu-link px-3"
                          data-kt-users-export="pdf"
                        >
                          <FontAwesomeIcon
                            icon={faFileExport}
                            className="me-2"
                          />
                          Exporter sous PDF
                        </a>
                      )}
                      content={() => componentRef.current}
                      documentTitle={`EGOU-EXPERT-Interventions-${
                        client?.sigle
                      }-${mission?.annee}-${moment().format("DDMMYYYY")}`}
                      pageStyle={pageStyle}
                      onBeforeGetContent={() => {
                        return new Promise((resolve) => {
                          setTimeout(() => {
                            resolve();
                          }, 500);
                        });
                      }}
                      onAfterPrint={() => {
                        console.log("Export PDF terminé");
                        setIsMenuOpen(false);
                      }}
                    />
                  </div>

                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      data-kt-users-export="excel"
                      onClick={(e) => {
                        e.preventDefault();
                        handleExportExcel();
                      }}
                    >
                      <FontAwesomeIcon icon={faFileUpload} className="me-2" />
                      Exporter sous Excel
                    </a>
                  </div>

                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      data-kt-users-export="word"
                      onClick={(e) => {
                        e.preventDefault();
                        handleExportWord();
                      }}
                    >
                      <FontAwesomeIcon icon={faFileUpload} className="me-2" />
                      Exporter sous Word
                    </a>
                  </div>
                </div>
              )}
            </div>
          </Tooltip>
        </Space>

        <FormContainer>
          <div className="py-4">
            <div className="table-responsive">
              <Table
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={filtersItems}
                pagination={tableParams.pagination}
                loading={loading}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </FormContainer>

        {/* Vue d'impression masquée */}
        <div style={{ display: "none" }}>
          <PrintComponent ref={componentRef} />
        </div>
      </div>
    </>
  );
};

export { Identification };
